import { NAVIGATE_REGISTER } from "../constant";

const PageLang = {
    projectTitle: {
        english: 'Mukhyamantri Rugna Mitra',
        marathi: 'मुख्यमंत्री रुग्ण मित्र',
    },

    projectSubtitle: {
        english: 'Your health, our priority – Find the nearest hospital instantly!',
        marathi: 'आपले आरोग्य, आमची प्राथमिकता – जवळचे रुग्णालय त्वरित शोधा!'
    },
    loginButtonText: {
        english: 'Login',
        marathi: 'लॉगिन'
    },
    TopText: {
        english: 'A',
        marathi: 'अ'
    },
    "filters": {
        "english": "Filters",
        "marathi": "फिल्टर"
    },
    commonRegisterTitle: {
        marathi: "आजच नोंदणी करा: आपले रुग्णालय किंवा रक्तपेढी या यादीत जोडा!",
        english: "Register Today: Add Your Hospital or Blood Bank!"
    },
    commonRegisterButtom: {
        english: 'Register',
        marathi: 'नोंदणी करा'
    },
    registerbloodBankButton: {
        english: 'Register Blood Bank Now',
        marathi: 'रक्तपेढी नोंदणी करा'
    },
    registerbloodBankContent: {
        marathi: 'आपली रक्तपेढी नोंदवा आणि आरोग्यसेवा अधिक मजबूत करा. रुग्णांना वेळेवर रक्तपुरवठा होण्यासाठी आजच सहभागी व्हा आणि अनेक जीवनं वाचवा.',
        english: 'Register your blood bank to support healthcare services and help patients receive timely blood. Join today and make a difference in saving lives.'
    },
    registerHospitalButton: {
        english: 'Register Hospital Now',
        marathi: 'रुग्णालयाची नोंदणी करा'
    },
    registerHospitalContent: {
        marathi: 'आपले रुग्णालय आमच्या आरोग्य नेटवर्कमध्ये जोडा आणि अधिक रुग्णांपर्यंत पोहोचा. आजच नोंदणी करा आणि डिजिटल आरोग्य क्रांतीचा भाग बना!.',
        english: 'Add your hospital to our healthcare network and reach more patients. Register today and be a part of the digital healthcare revolution.'
    },
    hospitalListSearchTitle: {
        marathi: '🔍 आपल्या जवळील आरोग्य सेवा शोधा',
        english: '🔍 Find Healthcare Services Near You'
    },
    TollFreeTitle: {
        marathi: "टोल-फ्री",
        english: "Toll-Free"
    },
    TollFreeNumber: {
        marathi: "१८००-१२३-२२११",
        english: "1800-123-2211"
    },
    hospitalListSliderTitle: [
        {
            english: "Your health, our priority – Find the nearest hospital instantly!",
            marathi: "आपले आरोग्य, आमची प्राथमिकता – जवळचे रुग्णालय त्वरित शोधा!"
        },
        {
            english: "Swastha Maharashtra, Digital Maharashtra – Smart Healthcare Access for All!",
            marathi: "सुदृढ महाराष्ट्र, डिजिटल महाराष्ट्र – सर्वांसाठी स्मार्ट आरोग्य सुविधा!"
        },
        {
            english: "A smart step towards health – Maharashtra's digital hospital search portal!",
            marathi: "आरोग्यासाठी स्मार्ट पाऊल – महाराष्ट्राचे डिजिटल रुग्णालय शोध पोर्टल!"
        }
    ],
    RegisterDialog: {
        Title: {
            key: 'registerasa',
            value: 'registerasa',
            english: 'Register As',
            marathi: 'नोंदणी करा',
        },
        DialogOptions: [
            {
                key: 'hospital-registration',
                value: 'hospital-registration',
                url: NAVIGATE_REGISTER.HOSPITAL_REGISTER_PAGE,
                icon: '/rugna-mitra/hospital.gif',
                english: 'Hospital Registration',
                marathi: 'रुग्णालय नोंदणी',
            },
            {
                key: 'bloodBank-registration',
                value: 'bloodBank-registration',
                url: NAVIGATE_REGISTER.BLOOD_BANK_REGISTER_PAGE,
                icon: '/rugna-mitra/blood-donation.gif',
                english: 'Blood Bank Registration',
                marathi: 'ब्लड बँक नोंदणी',
            }
        ],
        DialogFooter: {
            key: 'already-login',
            value: 'already-login',
            url: '/auth/login',
            english: 'Already a Member? Log In',
            marathi: 'आधीच सदस्य आहात? लॉगिन करा',
        },
    },
    searchCity: {
        marathi: 'शहर प्रविष्ट करा (उदा. पुणे)',
        english: 'Enter City (Eg. Pune)'
    },

    cities_in_maharashtra: [
        { "english": "Mumbai", "marathi": "मुंबई" },
        { "english": "Pune", "marathi": "पुणे" },
        { "english": "Nagpur", "marathi": "नागपूर" },
        { "english": "Thane", "marathi": "ठाणे" },
        { "english": "Pimpri-Chinchwad", "marathi": "पिंपरी-चिंचवड" },
        { "english": "Nashik", "marathi": "नाशिक" },
        { "english": "Kalyan-Dombivli", "marathi": "कल्याण-डोंबिवली" },
        { "english": "Vasai-Virar", "marathi": "वसई-विरार" },
        { "english": "Chhatrapati Sambhajinagar", "marathi": "छत्रपती संभाजीनगर" },
        { "english": "Navi Mumbai", "marathi": "नवी मुंबई" },
        { "english": "Solapur", "marathi": "सोलापूर" },
        { "english": "Mira-Bhayandar", "marathi": "मीरा-भाईंदर" },
        { "english": "Bhiwandi-Nizampur", "marathi": "भिवंडी-निजामपूर" },
        { "english": "Amravati", "marathi": "अमरावती" },
        { "english": "Nanded-Waghala", "marathi": "नांदेड-वाघाळा" },
        { "english": "Kolhapur", "marathi": "कोल्हापूर" },
        { "english": "Ulhasnagar", "marathi": "उल्हासनगर" },
        { "english": "Sangli-Miraj & Kupwad", "marathi": "सांगली-मिरज आणि कुपवाड" },
        { "english": "Malegaon", "marathi": "मालेगाव" },
        { "english": "Jalgaon", "marathi": "जळगाव" },
        { "english": "Akola", "marathi": "अकोला" },
        { "english": "Latur", "marathi": "लातूर" },
        { "english": "Dhule", "marathi": "धुळे" },
        { "english": "Ahilyanagar", "marathi": "अहिल्यानगर" },
        { "english": "Chandrapur", "marathi": "चंद्रपूर" },
        { "english": "Parbhani", "marathi": "परभणी" },
        { "english": "Ichalkaranji", "marathi": "इचलकरंजी" },
        { "english": "Jalna", "marathi": "जालना" },
        { "english": "Ambarnath", "marathi": "अंबरनाथ" },
        { "english": "Bhusawal", "marathi": "भुसावळ" },
        { "english": "Panvel", "marathi": "पनवेल" },
        { "english": "Badlapur", "marathi": "बदलापूर" },
        { "english": "Beed", "marathi": "बीड" },
        { "english": "Gondia", "marathi": "गोंदिया" },
        { "english": "Satara", "marathi": "सातारा" },
        { "english": "Barshi", "marathi": "बार्शी" },
        { "english": "Yavatmal", "marathi": "यवतमाळ" },
        { "english": "Achalpur", "marathi": "अचलपूर" },
        { "english": "Osmanabad", "marathi": "उस्मानाबाद" },
        { "english": "Nandurbar", "marathi": "नंदुरबार" },
        { "english": "Wardha", "marathi": "वर्धा" },
        { "english": "Udgir", "marathi": "उदगीर" },
        { "english": "Hinganghat", "marathi": "हिंगणघाट" },
        { "english": "Bhandara", "marathi": "भंडारा" },
        { "english": "Washim", "marathi": "वाशीम" },
        { "english": "Hingoli", "marathi": "हिंगोली" },
        { "english": "Gadchiroli", "marathi": "गडचिरोली" }
    ],

    searchbyPinServ: {
        english: 'Search by Pin Code, Hospital Name or Services...',
        marathi: 'पिन कोड, रुग्णालयाचे नाव किंवा सेवांद्वारे शोधा ...'
    },
    newBadge:{
        english:'NEW',
        marathi:'नवीन'
    },
    searchByPinBloodBank: {
        english: 'Search by Pin Code, Blood Bank Name or Components...',
        marathi: 'पिन कोड, रक्तपेढीचे नाव किंवा घटकांद्वारे शोधा...'
    },    
    searchResult: {
        english: 'Search Results for',
        marathi: 'शोध परिणाम'
    },

    services: {
        english: ' Services & Diseases :',
        marathi: 'सेवा आणि आजार :'
    },
    schemes: {
        english: 'Healthcare Schemes :',
        marathi: 'आरोग्य योजना :'
    },       
    clearefilter: {
        english: '🧹 Clear Filters',
        marathi: '🧹 फिल्टर साफ करा'
    },
    hospitalType: {
        english: 'Hospital Types :',
        marathi: 'रुग्णालयाचा प्रकार :'
    },
    hospitalTypeTitle: {
        english: 'Select Hospital Type :',
        marathi: 'रुग्णालयाचा प्रकार निवडा :'
    },
    bloodBankType: {
        english: 'Blood Bank Types :',
        marathi: 'रक्तपेढी प्रकार :'
    },
    search: {
        english: 'Search',
        marathi: 'शोधा'
    },    
    bloodBankTypeTitle: {
        english: 'Select Blood Bank Type :',
        marathi: 'रक्तपेढी प्रकार निवडा :'
    }, 
    bloodTestComponents: {
        english: 'Blood Test Components :',
        marathi: 'रक्त तपासणीचे घटक :'
    },      
    selectBloodTestComponents: {
        english: 'Select Blood Test Components and press Enter',
        marathi: 'रक्त तपासणीचे घटक निवडा आणि एंटर दाबा'
    },     
    servicesTitle: {
        english: "Type services and press Enter",
        marathi: "सेवा टाइप करा आणि एंटर दाबा"
    },
    schemesTitle: {
        english: 'Select Schemes',
        marathi: 'योजना निवडा'
    },

    hospitalListTitle: {
        english: 'Hospital List',
        marathi: 'रुग्णालयांची यादी'
    },
    bloodBankListTitle: {
        english: "Available Blood Banks",
        marathi: "उपलब्ध रक्तपेढ्या"
    },
     buttonLabel: {
        english: "View Blood Banks",
        marathi: "रक्तपेढ्या पहा"
    },      
    facilityListTitle: {
        english: 'Hospital & Blood Bank List',
        marathi: 'रुग्णालय व रक्तपेढ्यांची यादी'
    },
    in: {
        english: 'in',
        marathi: 'मध्ये'
    },

    detailsButton: {
        english: 'Hospital Details',
        marathi: 'रुग्णालयाची माहिती'
    },
    detailsBloodBankButton: {
        english: 'Blood Bank Details',
        marathi: 'ब्लड बँक तपशील'
    },    
    homeTitle: {
        english: 'Home',
        marathi: 'मुख्य पृष्ठ'
    },

    loginSignupButton: {
        key: 'login',
        value: 'login',
        english: 'Login / Signup',
        marathi: 'प्रवेश करा / नोंदणी करा',
    },
    mostPopularHosp: {
        english: 'Most Popular Hospitals',
        marathi: 'सर्वाधिक लोकप्रिय रुग्णालये'
    },
    mostPopularHosSubtitle: {
        english: 'Find top-rated hospitals with excellent facilities and trusted medical professionals.',
        marathi: 'उत्कृष्ट सुविधा आणि विश्वासार्ह वैद्यकीय तज्ज्ञांसह सर्वोत्तम रुग्णालये शोधा.'
    },

    mostPophospitalsList: [
        {
            "name": {
                "english": "All India Institute Of Medical Sciences",
                "marathi": "अखिल भारतीय आयुर्विज्ञान संस्थान"
            },
            "location": {
                "english": "Plot No. 2, Sector - 20, MIHAN, Nagpur, Maharashtra, Pin: 441108",
                "marathi": "प्लॉट नंबर २ , सेक्टर - २०, मिहान, नागपूर, महाराष्ट्र, पिन: ४४११०८"
            },
            "description": {
                "english": "super-specialty hospital with modern medical infrastructure, offering advanced diagnostic and therapeutic services in departments like Cardiology, Neurology, Oncology, Surgery, Pediatrics, and Orthopedics at affordable rates.",
                "marathi": "सुपर-स्पेशॅलिटी रुग्णालय आधुनिक वैद्यकीय पायाभूत सुविधांसह, जे कार्डिओलॉजी, न्यूरोलॉजी, ऑन्कोलॉजी, शस्त्रक्रिया, बालरोग आणि ऑर्थोपेडिक्ससारख्या विभागांमध्ये प्रगत निदान व उपचार सेवा परवडणाऱ्या दरात प्रदान करते.."
            },
            "logo": "/hospital/AIIMS.png",
            "services": {
                "english": "general surgery, orthopedics, surgical gastroenterology, urology, neurosurgery, Cardiology, Neurology, Oncology, Surgery, Pediatrics, Orthopedics",
                "marathi": "सामान्य शस्त्रक्रिया, अस्थिरोग, शस्त्रक्रियात्मक गॅस्ट्रोएन्टेरोलॉजी, मूत्रविज्ञान, मेंदू व मज्जासंस्थेशास्त्र, हृदयरोगशास्त्र, न्यूरोलॉजी, कर्करोगशास्त्र, शस्त्रक्रिया, बालरोग, अस्थिरोग."
            }
        },
        {
            "name": {
                "english": "BARC Hospital",
                "marathi": "बीएआरसी रुग्णालय"
            },
            "location": {
                "english": "Anushakti Colony, Anushakti Nagar, Mumbai - 400094, Maharashtra",
                "marathi": "अणुशक्ती कॉलनी, अणुशक्ती नगर, मुंबई - ४०००९४, महाराष्ट्र"
            },
            "description": {
                "english": "The Grant Government Medical College is a public medical college located in Mumbai, India. It is affiliated to the Maharashtra University of Health Sciences. Founded in 1845, it is one of the oldest medical colleges in South Asia.",
                "marathi": "सर्वोत्तम आरोग्य तज्ञ सर्वसमावेशक आरोग्य सेवा प्रदान करतात. हे रुग्णालय रेडिओलॉजी, जनरल मेडिसिन, डेंटिस्ट्री, स्त्रीरोग व प्रसूतीशास्त्र, नेत्ररोग, पॅथोलॉजी, अॅनेस्थेसियोलॉजी, ऑर्थोपेडिक्स आणि बालरोग यांसारख्या विविध विशेष शाखांमध्ये प्रगत स्तरावरील उपचार सेवा प्रदान करते."
            },
            "logo": "/hospital/BARC.jpg",
            "services": {
                "english": "Biochemistry, Clinical Pathology, Microbiology, Hematology, Blood Bank, Cytopathology, Molecular Genetics, Cancer Screening, Emergency Laboratory Services​, MRI, CT Scan, X-rays (including portable X-ray facilities), Ultrasound (3D/4D imaging), Color Doppler, specialized sonography for hepatobiliary, KUB, prostate, musculoskeletal conditions, Cardiology, Neurology, Oncology, Orthopedics, Pediatrics, Anesthesiology, Gynecology & Obstetrics, General Surgery, Urology, specialized surgical procedures, Immunizations, health check-ups, screenings",
                "marathi": "बायोकेमिस्ट्री, क्लिनिकल पॅथॉलॉजी, मायक्रोबायोलॉजी, हेमॅटोलॉजी, रक्तपेढी, साइटोपॅथॉलॉजी, मोलेक्युलर जेनेटिक्स, कर्करोग तपासणी, आपत्कालीन प्रयोगशाळा सेवा, एमआरआय, सीटी स्कॅन, एक्स-रे (पोर्टेबल एक्स-रे सुविधांसह), अल्ट्रासाऊंड (3D/4D इमेजिंग), कलर डॉपलर, यकृत-पित्ताशय, केयूबी, प्रोस्टेट, musculoskeletal स्थितीसाठी विशेष सोनोग्राफी, हृदयरोगशास्त्र, न्यूरोलॉजी, ऑन्कोलॉजी, अस्थिरोग, बालरोग, भूलशास्त्र, स्त्रीरोग व प्रसूतीशास्त्र, जनरल सर्जरी, मूत्रविज्ञान, विशेष शस्त्रक्रिया प्रक्रिया, लसीकरण, आरोग्य तपासणी, स्क्रिनिंग्स."
            }
        },
        {
            "name": {
                "english": "King Edward Memorial Hospital (KEM Hospital)",
                "marathi": "किंग एडवर्ड मेमोरिअल रुग्णालय  (केईएम रुग्णालय)"
            },
            "location": {
                "english": "Acharya Donde Road, Parel (East), Parel, Mumbai - 400012,Maharashtra",
                "marathi": "आचार्य डोंडे मार्ग, परळ (पूर्व), परळ, मुंबई - ४०००१२,महाराष्ट्र"
            },
            "description": {
                "english": "A premier government healthcare institution, the hospital delivers world-class medical treatment and education while ensuring comprehensive care across various specialties. From basic healthcare services to advanced surgical procedures, it offers high-quality treatment at minimal or no cost, prioritizing underserved communities and enhancing public health with cutting-edge medical facilities..",
                "marathi": "ही प्रमुख सरकारी आरोग्य संस्था आहे जी जागतिक दर्जाची वैद्यकीय उपचार आणि शिक्षण प्रदान करते. मूलभूत आरोग्य सेवा ते प्रगत शस्त्रक्रिया यांसाठी सर्वसमावेशक वैद्यकीय सेवा पुरवत असून, उच्च दर्जाचा उपचार अत्यल्प किंमतीत किंवा मोफत उपलब्ध करून देते. विशेषतः गरजू आणि वंचित समुदायांसाठी ही सुविधा उपयुक्त ठरते, तसेच अत्याधुनिक वैद्यकीय सोयीसुविधांसह सार्वजनिक आरोग्य सुधारण्यास मदत करते."
            },
            "logo": "/hospital/KEM.png",
            "services": {
                "english": "Liver Disease Treatment, Ulcerative Colitis Treatment, Acidity Treatment, Irritable Bowel Syndrome (IBS) Treatment.",
                "marathi": "यकृत रोग उपचार, अल्सरेटिव्ह कोलायटिस उपचार, अॅसिडिटी उपचार, चिडक्या आंत्र सिंड्रोम (IBS) उपचार."
            }
        },
        {
            "name": {
                "english": "Lokmanya Tilak Municipal General Hospital",
                "marathi": "लोकमान्य टिळक महानगरपालिका सामान्य रुग्णालय"
            },
            "location": {
                "english": "Dr. Babasaheb Ambedkar Road, sion (West), Mumbai - 400022, Maharashtra",
                "marathi": "डॉ. बाबासाहेब आंबेडकर मार्ग, सायन (पश्चिम), मुंबई - ४०००२२, महाराष्ट्र"
            },
            "description": {
                "english": "premier government healthcare institution and the first major referral hospital in the region.",
                "marathi": "लोकमान्य टिळक म्युनिसिपल जनरल हॉस्पिटल , सायन, मुंबई हे एक प्रमुख शासकीय आरोग्यसंस्था आणि या प्रदेशातील पहिले मोठे संदर्भ रुग्णालय आहे. "
            },
            "logo": "/hospital/LTMH.png",
            "services": {
                "english": "General Surgery, Orthopedics, Neurology, Neurosurgery, Cardiology, Urology, Nephrology, Oncology, Pulmonology, Endocrinology, Gastroenterology, Pediatrics, Gynecology & Obstetrics, ENT, Ophthalmology, Plastic Surgery, Dermatology, Psychiatry, Anesthesiology, Radiology, Pathology, Physiotherapy, Emergency & Trauma Care.",
                "marathi": "सामान्य औषधोपचार, सामान्य शस्त्रक्रिया, अस्थिरोग (ऑर्थोपेडिक्स), न्यूरोलॉजी, मेंदू आणि मज्जासंस्थेच्या शस्त्रक्रिया (न्युरोसर्जरी), हृदयरोग (कार्डिओलॉजी), मूत्रविज्ञान (युरोलॉजी), किडनी विकार (नेफ्रोलॉजी), कर्करोग उपचार (ऑन्कोलॉजी), फुफ्फुस रोगतज्ज्ञ (पल्मोनोलॉजी), अंतःस्रावशास्त्र (एंडोक्रिनोलॉजी), पचनसंस्थेचे विकार (गॅस्ट्रोएन्टेरोलॉजी), बालरोगतज्ज्ञ (पेडियाट्रिक्स), स्त्रीरोग व प्रसूतीशास्त्र (गायनॅकोलॉजी व ऑब्स्टेट्रिक्स), कान-नाक-घसा (ईएनटी), नेत्ररोग (ऑप्थॅल्मोलॉजी), प्लास्टिक सर्जरी, त्वचारोग (डर्माटोलॉजी), मनोरोग (सायकियाट्री), भूलतज्ज्ञ सेवा (अ‍ॅनेस्थेसियोलॉजी), रेडिओलॉजी, पॅथॉलॉजी, फिजिओथेरपी, आणीबाणी आणि ट्रॉमा केअर."
            }
        },
        {
            "name": {
                "english": "Gokuldas Tejpal Hospital",
                "marathi": "गोकुळदास तेजपाल रुग्णालय"
            },
            "location": {
                "english": "G. P. O, Lokmanya Tilak Rd, near Police Commissioners Office, Dhobi Talao, Chhatrapati Shivaji Terminus Area, Fort, Mumbai, 400001, Maharashtra",
                "marathi": "जी.पी.ओ., लोकमान्य टिळक मार्ग, पोलिस आयुक्त कार्यालयाजवळ, धोबी तलाव, छत्रपती शिवाजी टर्मिनस क्षेत्र, फोर्ट, मुंबई- ४००००१, महाराष्ट्र"
            },
            "description": {
                "english": "A government-operated multi-specialty hospital in Mumbai, recognized for offering free medical services and specialized care in general medicine, surgery, orthopedics, cardiology, neurology, gynecology, pediatrics, and trauma management.",
                "marathi": "मुंबईतील एक सरकारी मल्टी-स्पेशालिटी रुग्णालय, जे मोफत वैद्यकीय सेवा आणि सामान्य औषधोपचार, शस्त्रक्रिया, अस्थिरोग, हृदयरोग, मेंदूविकार, स्त्रीरोग, बालरोग आणि आपत्कालीन उपचारांमध्ये विशेष सेवा प्रदान करण्यासाठी ओळखले जाते."
            },
            "logo": "/hospital/GTH.jpg",
            "services": {
                "english": "orthopedics, neurology, cardiology, oncology, general surgery, laparoscopic surgery, bariatric surgery,  ICU and diagnostic facilities.",
                "marathi": "ऑर्थोपेडिक्स, न्यूरोलॉजी, कार्डिओलॉजी, ऑन्कोलॉजी, जनरल सर्जरी, लॅप्रोस्कोपिक सर्जरी, बॅरियाट्रिक सर्जरी, आयसीयू आणि डायग्नोस्टिक सुविधा."
            }
        },
        {
            "name": {
                "english": "pestonji cama and albless hospital",
                "marathi": "पेस्टोनजी कामा व आल्बलेस रुग्णालये"
            },
            "location": {
                "english": "Bmc office Mahapalika Marg opp. Azad Maidan, Dhobi Talao, Chhatrapati Shivaji Terminus Area, Fort, Mumbai,400001, Maharashtra",
                "marathi": "बृहन्मुंबई महानगरपालिका कार्यालय, महानगरपालिका मार्ग ,आझाद मैदानच्या समोर, धोबी तलाव, छत्रपती शिवाजी महाराज टर्मिनस क्षेत्र, फोर्ट, मुंबई -  ४००००१"
            },
            "description": {
                "english": "provides advanced levels of care across various specialties, including Gynecology and Obstetrics, ensuring comprehensive medical treatment and specialized healthcare services.",
                "marathi": "ही विविध वैद्यकीय तज्ञांच्या विशेष उपचारांसह स्त्रीरोग व प्रसूतीसह अनेक क्षेत्रांमध्ये प्रगत स्तरावरील आरोग्य सेवा प्रदान करते, संपूर्ण वैद्यकीय उपचार आणि विशेष आरोग्य सेवा सुनिश्चित करते."
            },
            "logo": "/hospital/Cama_Hospital.jpg",
            "services": {
                "english": "anaesthesiology, dentistry, emergency medicine, obstetrics & gynecology, oncology, pediatrics, and radiology",
                "marathi": "अनेस्थेसियोलॉजी, दंतचिकित्सा, आपत्कालीन औषधोपचार, प्रसूती आणि स्त्रीरोगशास्त्र, कर्करोगशास्त्र, बालरोगशास्त्र, आणि रेडिओलॉजी."
            }
        },
        {
            "name": {
                "english": "Sassoon Hospital",
                "marathi": "ससून रुग्णालय"
            },
            "location": {
                "english": "Sassoon Hospital, Agarkar Nagar, Pune, Maharashtra 411001",
                "marathi": "ससून हॉस्पिटल, अगारकर नगर, पुणे - ४११००१, महाराष्ट्र"
            },
            "description": {
                "english": "offer comprehensive healthcare services, including specialized treatments, to ensure accessibility for economically disadvantaged patient",
                "marathi": "आर्थिकदृष्ट्या दुर्बल रुग्णांना आरोग्यसेवा सहज उपलब्ध होण्यासाठी रुग्णालय सर्वसमावेशक आरोग्य सेवा तसेच विशेष उपचार प्रदान करते."
            },
            "logo": "/hospital/Sasoon.png",
            "services": {
                "english": "cardiology, neurosurgery, orthopedic surgery, pediatric surgery, plastic surgery, urology, ophthalmology, pathology, radiology, and general medicine",
                "marathi": "कार्डिओलॉजी, न्यूरोसर्जरी, ऑर्थोपेडिक सर्जरी, पेडियाट्रिक सर्जरी, प्लास्टिक सर्जरी, युरोलॉजी, नेत्ररोगशास्त्र, पॅथोलॉजी, रेडिओलॉजी आणि जनरल मेडिसिन."
            }
        },
        {
            "name": {
                "english": "St. George's Hospital",
                "marathi": "सेंट जॉर्जेस रुग्णालय"
            },
            "location": {
                "english": "P D'Mello Rd, Opposite GPO, Beside CST station, Chhatrapati Shivaji Terminus Area, Fort, Mumbai, 400001, Maharashtra",
                "marathi": "पी. डी’मेलो मार्ग, जी.पी.ओ.च्या समोर, छत्रपती शिवाजी महाराज टर्मिनस स्टेशनच्या बाजूला, छत्रपती शिवाजी महाराज टर्मिनस क्षेत्र, फोर्ट, मुंबई - ४००००१, महाराष्ट्र"
            },
            "description": {
                "english": "Provides high-quality healthcare services across multiple specialties, ensuring advanced treatment and comprehensive medical care.",
                "marathi": "विविध वैद्यकीय विशेष शाखांमध्ये प्रगत उपचार आणि सर्वसमावेशक वैद्यकीय सेवा प्रदान करणारे रुग्णालय"
            },
            "logo": "/hospital/SGH.jpg",
            "services": {
                "english": "General Surgery, Orthopedics, Obstetrics and Gynecology, Pediatrics, ENT (Ear, Nose, and Throat), Plastic Surgery, Urology, Ophthalmology, Radiology, Pathology, Laparoscopic Hysterectomy, Arthroscopy, Total Hip Replacement, Piles Laser Treatment.",
                "marathi": "सामान्य शस्त्रक्रिया, अस्थिरोग (ऑर्थोपेडिक्स), प्रसूती व स्त्रीरोग, बालरोग, ईएनटी (कान, नाक आणि घसा), प्लास्टिक सर्जरी, मूत्रविज्ञान (युरोलॉजी), नेत्ररोग (ऑफ्थल्मोलॉजी), रेडिओलॉजी, पॅथोलॉजी, लॅप्रोस्कोपिक हिस्टेरेक्टॉमी, आर्थ्रोस्कोपी, टोटल हिप रिप्लेसमेंट, मूळव्याध लेझर उपचार."
            }
        },
        {
            "name": {
                "english": "Government Medical College & Hospital",
                "marathi": "शासकीय वैद्यकीय महाविद्यालय व रुग्णालय"
            },
            "location": {
                "english": "Hanuman Nagar, Ajni Road, Medical Chowk, Ajni, Nagpur- 440003, Maharashtra",
                "marathi": "हनुमान नगर, अजनी रोड, मेडिकल चौक, अजनी, नागपूर - ४४०००३, महाराष्ट्र"
            },
            "description": {
                "english": "GMCH Nagpur provides comprehensive healthcare services, including various specialties like cardiology, neurology, oncology, pediatrics, and orthopedics.",
                "marathi": "जीएमसीएच नागपूर विविध वैद्यकीय तज्ज्ञ सेवा प्रदान करते, ज्यामध्ये कार्डिओलॉजी, न्यूरोलॉजी, ऑन्कोलॉजी, पेडियाट्रिक्स आणि ऑर्थोपेडिक्स यांचा समावेश आहे."
            },
            "logo": "/hospital/GMCN.png",
            "services": {
                "english": "cardiology, neurology, oncology, pediatrics, orthopedics.",
                "marathi": "कार्डिओलॉजी, न्यूरोलॉजी, ऑन्कोलॉजी, पेडियाट्रिक्स आणि ऑर्थोपेडिक्स.."
            }
        },
        {
            "name": {
                "english": "Sir J.J.Hospital",
                "marathi": "सर जे.जे. रुग्णालय"
            },
            "location": {
                "english": "J J Marg, Nagpada-Mumbai Central, Off Jijabhoy Road, Mumbai, 400008, Maharashtra",
                "marathi": "जे.जे. मार्ग, नागपाडा–मुंबई सेंट्रल, जिजाभॉय मार्ग लगत, मुंबई - ४००००८, महाराष्ट्र"
            },
            "description": {
                "english": "The multi-specality hospital offers comprehensive pediatric care, including critical care, nutrition, SIDS, fever, child/adolescent.",
                "marathi": "मल्टी-स्पेशॅलिटी रुग्णालय व्यापक बालरोग सेवा प्रदान करते, ज्यामध्ये अतिदक्षता सेवा, पोषण, सडस (SIDS), ताप, तसेच बालक आणि किशोरवयीन समस्यांचे उपचार समाविष्ट आहेत."
            },
            "logo": "/hospital/J J.jpg",
            "services": {
                "english": "pediatric critical care, children nutrition, treatment for sudden infant death syndrome (Sids), viral fever, child and adolescent problems, restless child disorder",
                "marathi": "बालरोग गहन उपचार, बालकांचे पोषण, अचानक शिशू मृत्यू संलक्षण (सिड्स) साठी उपचार, व्हायरल ताप, बालक आणि पौगंडावस्थेतील समस्या, अस्वस्थ बालक विकार."
            }
        }
    ],

    supportHelpline: {
        english: 'Support Helpline',
        marathi: 'सहाय्यासाठी हेल्पलाइन'
    },

    supportHelplineSubtitle: {
        english: 'Emergency medical services, health advice, grievance redressal & more..',
        marathi: 'आपत्कालीन वैद्यकीय सेवा, आरोग्य मार्गदर्शन, तक्रार निवारण आणि इतर उपयुक्त सुविधा.'
    },

    stayUpdated: {
        marathi: 'आमच्या आरोग्य सेवांबद्दल अपडेट रहा.',
        english: 'Stay Updated with Our Healthcare Services'
    },
    subscribeUpdates: {
        english: 'Subscribe to receive the latest updates on hospital services, health tips, and exclusive offers.',
        marathi: 'रुग्णालयातील सेवा, आरोग्य टिप्स आणि विशेष ऑफर्सबद्दल नवीन अपडेट्स मिळविण्यासाठी सदस्य व्हा.'
    },
    registerContent: {
        english: 'Join our network to provide seamless healthcare services and enhance patient care.',
        marathi: 'अखंड आरोग्य सेवा प्रदान करण्यासाठी आणि रुग्णसेवा वाढविण्यासाठी आमच्या नेटवर्कमध्ये सामील व्हा'
    },
    enterMail: {
        english: 'Enter your email',
        marathi: 'तुमचा ईमेल प्रविष्ट करा'
    },

    subscribeButton: {
        marathi: 'सदस्य व्हा',
        english: 'Subscribe'
    },

    Govtright: {
        english: `© ${new Date().getFullYear()} This is the official website of Government of Maharashtra. All Rights Reserved.`,
        marathi: `© ${new Date().getFullYear()} ही महाराष्ट्र सरकारची अधिकृत वेबसाइट आहे. सर्व हक्क राखीव.`
    },
    Address: {
        english: "Chief Minister's Relief Fund and Charitable Hospital Help Desk, Maharashtra",
        marathi: 'मुख्यमंत्री सहाय्यता निधी व धर्मादाय रूग्णालय मदत कक्ष, महाराष्ट्र'
    },
    whatsappTooltip: {
        english: 'Your health matters – Find a nearby hospital 🏥',
        marathi: 'तुमचे आरोग्य महत्त्वाचे आहे – जवळचे रुग्णालय शोधा 🏥'
    },
    smsTooltip: {
        english: "Share this hospital with those who need it! 🏥 Healthcare is just a step away.",
        marathi: "ही रुग्णालयाची माहिती गरजूंपर्यंत पोहोचवा! 🏥 आरोग्य सेवा तुमच्या अगदी जवळ."
    },
    nodatFilter: {
        english: "We couldn’t find any results. Try refining your filters or refresh the page to continue.",
        marathi: "आम्हाला कोणतेही परिणाम मिळाले नाहीत. कृपया फिल्टर बदला किंवा पृष्ठ रीफ्रेश करा."
    },

    nodata: {
        english: "No Records to Display",
        marathi: "दर्शविण्यासाठी कोणत्याही नोंदी नाहीत"
    },
    termsConditionTitle: {
        english: 'Terms and Conditions',
        marathi: 'अटी व शर्ती'
    },
    termsCondition: {
        english: 'This website is designed, developed, and maintained by the Mukhyamantri Rugna Mitra, Government of Maharashtra. The information on this website is provided by the Chief Minister’s Office. By using this website, it is assumed that you unconditionally accept the terms and conditions of use. If you do not agree with these terms and conditions, please do not use this website. Although every effort has been made to ensure the accuracy of the content on this site, it cannot be used as legal evidence. In case of any doubt, users must verify the information with the concerned officer at the Chief Minister’s Fund Office. The Government of Maharashtra will not be responsible for any costs, losses, adverse effects, or damage incurred while using this website. These terms and conditions will be governed by Indian laws. Any dispute arising with respect to these terms and conditions will fall under the jurisdiction of Indian courts.',
        marathi: 'या संकेतस्थळाची रचना, विकसन आणि देखभाल मुख्यमंत्री रुग्णमित्र , महाराष्ट्र शासन मार्फत केली आहे. या संकेतस्थळावरील माहिती मुख्यमंत्री कार्यालयामार्फत पुरविली आहे. संकेतस्थळाचा वापर करताना, वापराबाबतचे नियम आणि अटी तुम्ही बिनशर्त मान्य करता असे गृहीत धरले जाते. हे नियम आणि अटी तुम्हांला मान्य नसतील तर कृपया या संकेतस्थळाचा वापर करू नका. या संकेतस्थळावरील मजकुराच्या सत्यतेबाबत सर्वतोपरी खबरदारी घेतली गेली असली, तरी हा मजकूर कोणत्याही कायदेशीर कारणासाठी पुरावा म्हणून वापरता येणार नाही. याबाबत कोणत्याही प्रकारची शंका असल्यास वापरकर्त्याने संबंधीत अधिकारी,मुख्यमंत्री कार्यालयाकडून खातरजमा करून घ्यावी. या संकेतस्थळाचा वापर करीत असताना कोणत्याही प्रकारचा खर्च, तोटा, दुष्परिणाम अथवा हानी झाल्यास त्यासाठी महाराष्ट्र शासन जबाबदार राहणार नाही. भारतीय कायद्यानुसार या अटी आणि नियमांचे नियंत्रण केले जाईल. या अटी आणि नियमासंदर्भातील कोणत्याही प्रकारचा वाद भारताच्या न्यायालयीन अधिकार क्षेत्रात राहील.'
    },
    privacyTitle: {
        english: 'Privacy Policy',
        marathi: 'गोपनीयता धोरण'
    },
    privacyPolicy: {
        english: 'As a general rule, this website does not automatically collect any personal information (such as name, phone number, or email) that could identify you. The portal records visit timings and session access data (like Internet Protocol, domain name, browser type, operating system, date and time of visit, etc.) for statistical purposes. We do not use this data to establish your identity. However, in case of any attempt to compromise the website’s security, this information may be used to trace the source. We do not monitor users or their browsing activity. If the Mukhyamantri Rugna Mitra portal requests personal information from you, you will be informed about how it will be used, and adequate steps will be taken to maintain its confidentiality.',
        marathi: 'एक सर्वसाधारण नियम म्हणून हे संकेतस्थळ तुमची व्यक्तिगत ओळख स्पष्ट करणारी कोणत्याही प्रकारची माहिती (जसे नाव, दूरध्वनी क्र. अथवा ई-मेल) स्वयंचलितरित्या आपल्याकडे ठेवत नाही. हे पोर्टल तुमच्या भेटीच्या वेळा आणि सत्रप्रवेश अशा प्रकारच्या माहितीची, सांख्यिकीय हेतूसाठी (जसे इंटरनेट प्रोटोकॉल, डोमेन नेम, ब्राउजर प्रकार, ऑपरेटिंग सिस्टम, भेटीची तारीख आणि वेळ इ.) नोंद घेते. तुमच्या वैयक्तिक भेटीची नोंद असावी, या उद्देशाने आम्ही ही माहिती बाळगत नाही. आमच्या संकेतस्थळाच्या सुरक्षेला बाधा पोहोचवण्याचा प्रयत्न झाल्यास त्याचा मागोवा घेण्यासाठी आम्हाला या माहितीचा उपयोग होतो. संकेतस्थळ वापरणाऱ्या व्यक्तीने या संकेतस्थळावर कोणती माहिती / तपशील पाहिले, यावर आम्ही लक्ष ठेवत नाही. जर मुख्यमंत्री रुग्णमित्र पोर्टल तुमच्याकडून  वैयक्तिक माहितीची मागणी केल्यास, ती कशाप्रकारे आणि कशासाठी वापरली जाईल, हे तुम्हांला सांगितले जाईल; तसेच या माहितीची गोपनीयता राखण्यासाठी पुरेशी खबरदारी घेतली जाईल.'
    },
    copyrightTitle: {
        english: 'Copyright Policy',
        marathi: 'कॉपीराइट धोरण'
    },
    copyrightPolicy: {
        english: 'The content on this website is the property of the Government of Maharashtra and may be reproduced in any format or medium without permission, free of charge. However, it must be used as-is, without any distortion. Misleading or unverified use is not allowed. Proper acknowledgment of the original source is mandatory when using this information.',
        marathi: 'या संकेतस्वथळावरील मजकूर व माहिती महाराष्ट्र शासनाची मालमत्ता आहे. ती कोणत्याही स्वरूपात अथवा माध्यमात विनामूल्य पुनर्मुद्रित केली जाऊ शकते, मात्र त्यामध्ये कोणत्याही प्रकारचा बदल अथवा  विपर्यास केली जाणार नाही. चुकीच्या किंवा दिशाभूल करणाऱ्या पद्धतीने वापर करण्यास सक्त मनाई आहे. माहितीचा वापर करताना मूळ स्त्रोताचे योग्य श्रेय (Acknowledgement) देणे अनिवार्य आहे.'
    },
    disclaimerTitle: {
        english: 'Disclaimer and Policies',
        marathi: 'अस्वीकरण व धोरणे'
    },
    disclaimerPolicy: {
        english: 'Although the information and content on this website has been carefully and diligently made available, the  Mukhyamantri Rugna Mitra and Charitable Hospital Assistance Cell does not accept any responsibility for the use of this information or any consequences arising from such use. In case of any discrepancy or confusion, the user should contact the concerned officer at the Mukhyamantri Rugna Mitra office for further clarification.',
        marathi: 'या संकेतस्थळावरील माहिती व मजकूर काळजीपूर्वक आणि काटेकोरपणे उपलब्ध करून देण्यात आला आहे. तरीदेखील, मुख्यमंत्री रुग्णमित्र  व धर्मादाय रुग्णालय मदत कक्ष या माहितीच्या वापरासाठी किंवा त्या वापरामुळे होणाऱ्या कोणत्याही परिणामांसाठी जबाबदार राहणार नाही. काही विसंगती किंवा शंका असल्यास, वापरकर्त्यांनी अधिक स्पष्टतेसाठी मुख्यमंत्री रुग्णमित्र कार्यालयातील संबंधित अधिकाऱ्यांशी संपर्क साधावा.'
    },
    hyperlinkTitle: {
        english: 'Hyperlink Policy',
        marathi: 'हायपरलिंकिंग धोरण'
    },
    hyperlinkTitleSubTitleOne: {
        english: 'Links to External Websites/Portals',
        marathi: 'बाह्य वेबसाइट्स/पोर्टल्सकडे दुवे'
    },
    hyperlinkTitleSubTextOne: {
        english: 'At some places on this website, you may find links to other websites/portals. These are created and maintained by various government agencies and are provided for your convenience. When you select an external link, you exit this website. Your privacy and security policies then apply to the owner/sponsor of that external site. The Mukhyamantri Rugna Mitra is not responsible for the information or reliability of any external websites, nor do we endorse the views expressed therein. The inclusion of any external link should not be construed as an endorsement.',
        marathi: 'या संकेतस्थळावरील काही ठिकाणी इतर शासकीय वेबसाइट्स/पोर्टल्सचे दुवे दिलेले असू शकतात. हे दुवे तुमच्या सोयीसाठी उपलब्ध करून देण्यात आले आहेत. एकदा बाह्य दुवा निवडल्यावर, तुम्ही या वेबसाइटच्या बाहेर जाता. त्या नंतर, तुमची गोपनीयता आणि सुरक्षिततेसंबंधी धोरणे त्या बाह्य वेबसाइटच्या मालक/प्रायोजक यांच्याकडे लागू होतात. मुख्यमंत्री रुग्णमित्र वेबसाइट्सवरील माहिती किंवा विश्वासार्हतेसाठी जबाबदार नाही आणि त्यामध्ये मांडलेल्या विचारांना समर्थन देत नाही.'
    },
    hyperlinkTitleSubTitleTwo: {
        english: 'Linking to the Mukhyamantri Rugna Mitra from Other Websites/Portals',
        marathi: 'मुख्यमंत्री रुग्णमित्र वेबसाइटकडे इतर वेबसाइट्स/पोर्टल्समधून दुवे देणे'
    },
    hyperlinkTitleSubTextTwo: {
        english: 'If you wish to provide a link to the Mukhyamantri Rugna Mitra  website from other websites/portals, prior permission is not required. However, we do not permit the pages of our site to be displayed within frames of your site. The pages must open in a new browser window.',
        marathi: 'इतर कोणत्याही वेबसाइट/पोर्टलवरून मुख्यमंत्री रुग्णमित्र संकेतस्थळाचा दुवा देण्यासाठी पूर्वपरवानगी आवश्यक नाही. तथापि, मात्र तुमच्या संकेतस्थळाच्या चौकटीमध्ये आमचे पृष्ठ दाखवण्याची परवानगी आम्ही देत नाही. आमच्या संकेतस्थळावरील पृष्ठे, वापरकर्त्याच्या नवीन ब्राउजर विंडोमध्ये उघडायला हवीत.'
    },
    HowitworksTitle: [
        {
            title: {
                english: 'Find the Right Doctor',
                marathi: 'योग्य डॉक्टर शोधा'
            },
            description: {
                english: "Search for specialized doctors and book an appointment with ease.",
                marathi: "तज्ज्ञ डॉक्टर शोधा आणि अपॉइंटमेंट सहज बुक करा."
            },
            icon: 'WorkOutlineOutlined',

        },
        {
            title: {
                english: 'Get Quality Medical Care',
                marathi: 'गुणवत्तापूर्ण वैद्यकीय सेवा मिळवा'
            },
            description: {
                english: "Access top-tier healthcare services and treatment options tailored to your needs.",
                marathi: "आपल्या गरजेनुसार सर्वोत्तम आरोग्यसेवा आणि आधुनिक उपचार सुविधा मिळवा.",
            },
            icon: 'MedicalServicesOutlined',
        },
        {
            title: {
                english: 'Explore Our Facilities',
                marathi: 'आमच्या सुविधांचा शोध घ्या'
            },
            description: {
                english: "Discover advanced medical equipment and comfortable patient care environments.",
                marathi: "प्रगत वैद्यकीय उपकरणे आणि आरामदायी रुग्णसेवेचे उत्कृष्ट वातावरण अनुभवा.",
            },
            icon: 'Explore',

        },
        {
            title: {
                english: 'Find Hospitals Near You',
                marathi: 'तुमच्या जवळील रुग्णालये शोधा'
            },
            description: {
                english: "Enter your pincode and address to see all hospitals available in your area.",
                marathi: "तुमचा पिनकोड व पत्ता टाका आणि तुमच्या परिसरातील सर्व रुग्णालयांची सविस्तर माहिती मिळवा.",
            },
            icon: 'Search',
        }


    ],

    faqData: [
        {
            category: { english: "General Questions", marathi: "सामान्य प्रश्न" },
            questions: [
                {
                    question: {
                        english: "What is this crowdfunding portal?",
                        marathi: "ही क्राउडफंडिंग पोर्टल काय आहे?",
                    },
                    answer: {
                        english: "This is an official crowdfunding platform by the Government of Maharashtra, designed to raise funds for social causes, medical emergencies, disaster relief, and infrastructure development in a transparent and accountable manner.",
                        marathi: "ही महाराष्ट्र सरकारची अधिकृत क्राउडफंडिंग प्लॅटफॉर्म आहे, जी सामाजिक कारणे, वैद्यकीय आपत्कालीन परिस्थिती, आपत्ती निवारण आणि पायाभूत सुविधा विकासासाठी निधी उभारण्यासाठी पारदर्शक आणि जबाबदार पद्धतीने तयार करण्यात आली आहे.",
                    },
                },
                {
                    question: {
                        english: "Who can create fundraising campaigns?",
                        marathi: "फंडरेझिंग मोहिमा कोण तयार करू शकतो?",
                    },
                    answer: {
                        english: "Individuals, NGOs, medical institutions, and government bodies can create campaigns, subject to verification and approval by the relevant authorities.",
                        marathi: "व्यक्ती, स्वयंसेवी संस्था (NGO), वैद्यकीय संस्था आणि शासकीय संस्था संबंधित अधिकाऱ्यांच्या पडताळणी आणि मंजुरीच्या अधीन राहून मोहिमा तयार करू शकतात.",
                    },
                },
                {
                    question: {
                        english: "Is this platform secure and government-approved?",
                        marathi: "ही प्लॅटफॉर्म सुरक्षित आणि सरकारी मान्यताप्राप्त आहे का?",
                    },
                    answer: {
                        english: "Yes, this is an official government-backed platform with secure transactions and strict compliance with legal and financial guidelines.",
                        marathi: "होय, ही एक सरकारी-समर्थित अधिकृत प्लॅटफॉर्म आहे, ज्यामध्ये सुरक्षित व्यवहार आणि कायदेशीर तसेच आर्थिक मार्गदर्शक तत्त्वांचे कठोर पालन केले जाते.",
                    },
                },
            ],
        },
        {
            category: { english: "For Donors", marathi: "दाताांसाठी" },
            questions: [
                {
                    question: {
                        english: "How can I donate to a campaign?",
                        marathi: "मी मोहिमेसाठी देणगी कशी देऊ शकतो?",
                    },
                    answer: {
                        english: "You can browse active campaigns, select a cause, and donate using various payment methods, including UPI, credit/debit cards, net banking, and digital wallets.",
                        marathi: "तुम्ही सक्रिय मोहिमा ब्राउझ करू शकता, एखादे कारण निवडू शकता आणि UPI, क्रेडिट/डेबिट कार्ड, नेट बँकिंग आणि डिजिटल वॉलेट यासह विविध पेमेंट पद्धतींचा वापर करून देणगी देऊ शकता.",
                    },
                },
                {
                    question: {
                        english: "Is my donation tax-exempt?",
                        marathi: "माझी देणगी करमुक्त आहे का?",
                    },
                    answer: {
                        english: "Yes, donations made to verified campaigns may be eligible for tax exemptions under relevant government regulations. A tax receipt will be provided.",
                        marathi: "होय, सत्यापित मोहिमांसाठी दिलेल्या देणग्या संबंधित सरकारी नियमांनुसार करसवलतीसाठी पात्र असू शकतात. कर पावती प्रदान केली जाईल.",
                    },
                },
                {
                    question: {
                        english: "Can I track how my donation is being used?",
                        marathi: "मी माझ्या देणगीचा वापर कसा होत आहे हे ट्रॅक करू शकतो का?",
                    },
                    answer: {
                        english: "Absolutely! The platform provides real-time tracking of fund utilization through a publicly accessible transparency dashboard.",
                        marathi: "नक्कीच! प्लॅटफॉर्म सार्वजनिकरित्या प्रवेशयोग्य पारदर्शकता डॅशबोर्डद्वारे निधीच्या वापराचे वास्तविक-वेळ ट्रॅकिंग प्रदान करते.",
                    },
                },
                {
                    question: {
                        english: "Will I receive a donation receipt?",
                        marathi: "मला देणगीची पावती मिळेल का?",
                    },
                    answer: {
                        english: "Yes, a digital receipt will be sent to your registered email and mobile number after a successful donation.",
                        marathi: "होय, यशस्वी देणगी दिल्यानंतर तुमच्या नोंदणीकृत ईमेल आणि मोबाईल क्रमांकावर डिजिटल पावती पाठवली जाईल.",
                    },
                },
            ],
        },
        {
            category: { english: "For Campaign Creators", marathi: "मोहिम निर्मात्यांसाठी" },
            questions: [
                {
                    question: {
                        english: "How do I create a fundraising campaign?",
                        marathi: "मी फंडरेझिंग मोहीम कशी तयार करू?",
                    },
                    answer: {
                        english: "You need to register, provide campaign details, and submit required documents for verification. Once approved, your campaign will go live.",
                        marathi: "तुम्हाला नोंदणी करावी लागेल, मोहीमेचे तपशील द्यावे लागतील आणि पडताळणीसाठी आवश्यक कागदपत्रे सादर करावी लागतील. मंजुरी मिळाल्यानंतर तुमची मोहीम लाइव्ह होईल.",
                    },
                },
                {
                    question: {
                        english: "How long does the approval process take?",
                        marathi: "मंजुरी प्रक्रिया किती वेळ घेते?",
                    },
                    answer: {
                        english: "The approval process typically takes 3-5 business days, depending on the complexity and verification requirements of the campaign.",
                        marathi: "मंजुरी प्रक्रिया साधारणतः ३-५ व्यवसाय दिवस लागते, मोहिमेच्या गुंतागुंतीवर आणि पडताळणीच्या आवश्यकतांवर अवलंबून.",
                    },
                },
                {
                    question: {
                        english: "How will the raised funds be disbursed?",
                        marathi: "उभारलेले निधी कसे वितरित केले जातील?",
                    },
                    answer: {
                        english: "Funds will be released in phases based on predefined milestones, ensuring they are used appropriately.",
                        marathi: "पूर्वनियोजित टप्प्यांनुसार निधी टप्प्याटप्प्याने वितरित केला जाईल, याची खात्री केली जाईल की त्याचा योग्य वापर होतो.",
                    },
                },
                {
                    question: {
                        english: "Can I edit my campaign after it is published?",
                        marathi: "माझी मोहीम प्रकाशित झाल्यानंतर मी ती संपादित करू शकतो का?",
                    },
                    answer: {
                        english: "Limited edits (such as updates and additional information) are allowed. However, key details like the goal amount and purpose cannot be changed after approval.",
                        marathi: "मर्यादित संपादन (जसे की अद्यतन आणि अतिरिक्त माहिती) करण्याची परवानगी आहे. तथापि, मंजुरीनंतर मुख्य तपशील जसे की लक्ष्य रक्कम आणि उद्देश बदलता येणार नाही.",
                    },
                },
            ],
        },
        {
            category: { english: "Transparency & Security", marathi: "पारदर्शकता आणि सुरक्षितता" },
            questions: [
                {
                    question: {
                        english: "How does the platform ensure transparency and prevent fraud?",
                        marathi: "प्लॅटफॉर्म पारदर्शकता कशी सुनिश्चित करते आणि फसवणूक कशी रोखते?",
                    },
                    answer: {
                        english: "The platform includes AI-based fraud detection, regular audits, and a compliance monitoring system to ensure fund integrity.",
                        marathi: "प्लॅटफॉर्ममध्ये एआय-आधारित फसवणूक शोध प्रणाली, नियमित लेखापरीक्षण आणि निधीची विश्वासार्हता सुनिश्चित करण्यासाठी अनुपालन देखरेख प्रणाली समाविष्ट आहे.",
                    },
                },
            ],
        },


    ],

}

export default PageLang;
